import { createContext, useContext, useMemo } from 'react';
import { useUser } from '@clerk/clerk-react';
import type { CurrentUser } from '../services/api';

export const AppUserContext = createContext<{ acting: boolean; user: CurrentUser | null } | null>(
  null
);
export function useAppUser() {
  const provider = useUser();
  const context = useContext(AppUserContext);
  const target = context?.acting ? context.user : null;
  const real = provider.user;
  const targetUser = useMemo(() => {
    const name = target?.name || '';
    return target
      ? {
          id: target.clerkId,
          databaseId: target.id,
          fullName: name,
          firstName: name.split(' ')[0],
          lastName: name.split(' ').slice(1).join(' '),
          imageUrl: target.photo || '',
          primaryEmailAddress: { emailAddress: target.email },
        }
      : null;
  }, [target]);
  const user = target ? targetUser : (real as typeof real & { databaseId?: undefined });
  return {
    user,
    isLoaded: provider.isLoaded,
    isSignedIn: provider.isSignedIn,
    isSupportSession: !!context?.acting || !!(window as any).Clerk?.session?.actor,
  };
}
